import axios from 'axios';
import { API_BASE_URL, API_ENDPOINTS } from '@/config/api.config';

export const userService = {
  async getUsers(params = {}) {
    try {
      const response = await axios.get(
        `${API_BASE_URL}${API_ENDPOINTS.USERS.BASE}`,
        {
          params,
        },
      );
      return response.data;
    } catch (error) {
      console.error('getUsers service error:', error);
      throw error;
    }
  },

  async getUser(id) {
    try {
      const response = await axios.get(
        `${API_BASE_URL}${API_ENDPOINTS.USERS.BY_ID(id)}`,
      );
      return response.data;
    } catch (error) {
      console.error('getUser service error:', error);
      throw error;
    }
  },

  async createUser(userData) {
    try {
      const response = await axios.post(
        `${API_BASE_URL}${API_ENDPOINTS.USERS.BASE}`,
        userData,
      );
      return response.data;
    } catch (error) {
      console.error('createUser service error:', error);
      throw error;
    }
  },

  async updateUser(id, userData) {
    try {
      const response = await axios.put(
        `${API_BASE_URL}${API_ENDPOINTS.USERS.BY_ID(id)}`,
        userData,
      );
      return response.data;
    } catch (error) {
      console.error('updateUser service error:', error);
      throw error;
    }
  },

  async deleteUser(id) {
    try {
      const response = await axios.delete(
        `${API_BASE_URL}${API_ENDPOINTS.USERS.BY_ID(id)}`,
      );
      return response.data;
    } catch (error) {
      console.error('deleteUser service error:', error);
      throw error;
    }
  },

  /**
   * Envoie a ce compte un mot de passe temporaire, par courriel.
   *
   * Le mot de passe ne revient pas dans la reponse: il est dans la boite aux
   * lettres de son titulaire, et nulle part ailleurs - surtout pas dans une
   * reponse HTTP que l'on pourrait afficher.
   */
  async sendTemporaryPassword(id) {
    const response = await axios.post(
      `${API_BASE_URL}${API_ENDPOINTS.USERS.TEMPORARY_PASSWORD(id)}`,
    );
    return response.data;
  },

  /** Ce que l'import attend: les champs, et les roles que l'on peut attribuer. */
  async getImportOptions() {
    const response = await axios.get(
      `${API_BASE_URL}${API_ENDPOINTS.USERS.IMPORT_OPTIONS}`,
    );
    return response.data;
  },

  /** Le modele a remplir, en classeur. */
  async getImportTemplate() {
    const response = await axios.get(
      `${API_BASE_URL}${API_ENDPOINTS.USERS.IMPORT_TEMPLATE}`,
      { responseType: 'blob' },
    );
    return response.data;
  },

  /**
   * Fait lire le fichier par l'API: c'est elle qui comprend le .xlsx comme le
   * .csv, et qui propose une correspondance a partir des en-tetes.
   */
  async inspectImport(file) {
    const form = new FormData();
    form.append('file', file);

    const response = await axios.post(
      `${API_BASE_URL}${API_ENDPOINTS.USERS.IMPORT_INSPECT}`,
      form,
    );
    return response.data;
  },

  /** Lance l'import. Tout est revalide cote serveur avant la moindre creation. */
  async importUsers({ mapping, columns, rows }) {
    const response = await axios.post(
      `${API_BASE_URL}${API_ENDPOINTS.USERS.IMPORT}`,
      { mapping, columns, rows },
    );
    return response.data;
  },

  /** Le rapport d'erreurs, en francais, en classeur. */
  async getImportReport(errors) {
    const response = await axios.post(
      `${API_BASE_URL}${API_ENDPOINTS.USERS.IMPORT_REPORT}`,
      { errors },
      { responseType: 'blob' },
    );
    return response.data;
  },

  async exportUsers(params = {}) {
    try {
      const response = await axios.get(
        `${API_BASE_URL}${API_ENDPOINTS.USERS.BASE}/export`,
        {
          params,
          responseType: 'blob',
        },
      );
      return response.data;
    } catch (error) {
      console.error('exportUsers service error:', error);
      throw error;
    }
  },
};
